import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
`;

export default class GetUrl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      path: ""
    };
  }

  componentDidMount() {
    let oldHref = window.location.pathname;
    setInterval(() => {
      if (oldHref !== window.location.pathname) {
        oldHref = window.location.pathname;
        this.setState({ path: window.location.pathname });
      }
    }, 50);
    this.setState({ path: window.location.pathname });
  }

  // componentDidUpdate() {
  //   this.setState({ url: window.location.pathname });
  // }

  render() {
    const { Child, data } = this.props;
    const { path } = this.state;
    return (
      <Wrapper>{Child ? <Child data={data} path={path} /> : null}</Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/GetUrl.js